import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='min-vh-100'>
      <h1>Privacy Policy</h1>
      <p>
        At Deepstone Capital, we are committed to maintaining the trust and confidence of our visitors to our website. Here you’ll find information on how we treat data that we collect from visitors to our website.
      </p>
      <h2>Information We Collect</h2>
      <p>
        We may collect, store and use the following kinds of personal information: information about your computer and about your visits to and use of this website, etc.
      </p>
      <h2>Using Your Personal Information</h2>
      <p>
        Personal information submitted to us via this website will be used for the purposes specified in this privacy policy or in relevant parts of the website.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
